import styled from 'styled-components';

const InlineCode = styled.code`
    padding: 1px 6px;
    background: ${(props) => props.theme.colors.bg.tertiary || '#ececec'};
    border: 1px solid ${(props) => props.theme.colors.border.secondary};
    border-radius: 6px;
    display: inline-block;
    font-size: 0.72rem;
    line-height: 1.3;
    vertical-align: middle;
`;

export default InlineCode;
